// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__f1QSw","nav__item":"nav_nav__item__Y9rC5","nav__link":"nav_nav__link__NxOAO","icon":"nav_icon__RXVLs","glictch":"nav_glictch__NwbWU"};